export const defaultQueue = 'customerservice_1';

//
/**
 * enum from register-callback-api
 * https://github.devops.topdanmark.cloud/Glootie/register-callback-api/blob/master/src/helpers/dnis.helper.ts
 */
export enum Segment {
  PRIVATE = 'Privat',
  AGRICULTURE = 'Landbrug',
  LEASUREAGRI = 'Fritidslandbrug',
  PROFESSIONAL = 'Erhverv',
  COMMON = 'common',
  CLAIMS = 'Skade',
  ASAP = 'Kundeservice_ASAP',
}

export enum Subjects {
  CLAIMS_OTHER = 'Andre skader',
  CLAIMS_TRAVEL = 'Rejseskade',
  CLAIMS_PERSONAL = 'Personskade',
  CLAIMS_ANIMAL = 'Dyreforsikring',
  CLAIMS_BUILDING = 'Bygningsskade',
  CLAIMS_AUTO = 'Autoskade',
  CLAIMS_CONTENT = 'Løsøreskade',
  KUNDESERVICE = 'Kundeservice',
  TILBUD = 'Tilbud på forsikringer',
  SKADER = 'Skader',
  SERVICETJEK = 'Servicetjek',
  SALGSCENTER = 'Erhverv Salgscenter WCB Tilbud',
  IT = 'IT Teknisk hjælp',
  NETMODE = 'Netmøde',
  PHONE = 'Phone',
}
